module.exports = {
  "id": "muff",
  "title": "muff",
  "image": "provision/parts/muff/muff.png",
  "info": [
    {
      "text": "Add muff to your project",
      "image": "provision/parts/muff/muff.png"
    }
  ],
  "exposedVariables": []
};